import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "regles-widget-group" }
const _hoisted_2 = { class: "site-widget-container" }
const _hoisted_3 = {
  key: 0,
  class: "site-widget"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "card-content"
}
const _hoisted_6 = { class: "tiles-container" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "text" }
const _hoisted_9 = { class: "text accent" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderWidget = _resolveComponent("HeaderWidget")!
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_NoData = _resolveComponent("NoData")!
  const _component_Tile = _resolveComponent("Tile")!
  const _component_ContentLoader = _resolveComponent("ContentLoader")!
  const _component_ElevatedCard = _resolveComponent("ElevatedCard")!

  return (_openBlock(), _createBlock(_component_ElevatedCard, { widthType: 'third' }, {
    default: _withCtx(() => [
      _createVNode(_component_HeaderWidget, {
        iconUrl: _ctx.loadIcon,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.navigateTo('/facturation'))),
        title: _ctx.widget.libelle
      }, null, 8, ["iconUrl", "title"]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ReglePastille, { cle: "dashboard.widgetFacturationDroit" }),
        _createVNode(_component_ReglePastille, { cle: "dashboard.widgetPerimetreCommun" })
      ]),
      _createElementVNode("div", _hoisted_2, [
        (_ctx.widget.sites == null || _ctx.widget.sites.length > 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('multisites')), 1))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.widget.sites, (site) => {
              return (_openBlock(), _createElementBlock("span", {
                key: site.id,
                class: "site-widget"
              }, [
                _createTextVNode(_toDisplayString(site.description) + " ", 1),
                (site.id !== _ctx.widget.sites[_ctx.widget.sites.length - 1].id)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, ", "))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
      ]),
      (
                !_ctx.isLoading &&
                !_ctx.getBillingData.nbEnAttente &&
                !_ctx.getBillingData.nbMaxJourRetard &&
                !_ctx.getBillingData.nbEnRetard &&
                !_ctx.getBillingData.nbPayees
            )
        ? (_openBlock(), _createBlock(_component_NoData, {
            key: 0,
            class: "no-data",
            textNoData: "widget.billing.noData"
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_Tile, {
                class: "tile",
                value: _ctx.getBillingData.nbEnRetard,
                titleNotBold: _ctx.$t('widgetBilling.facture', _ctx.getBillingData.nbEnRetard),
                titleInBold: _ctx.$t('widgetBilling.retard'),
                titleEnd: _ctx.$t('widgetBilling.paiement'),
                color: '--erreur',
                fontSize: '19px',
                isLoading: _ctx.isLoading,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.navigateTo('/facturation/')))
              }, null, 8, ["value", "titleNotBold", "titleInBold", "titleEnd", "isLoading"]),
              _createVNode(_component_Tile, {
                class: "tile",
                value: _ctx.getBillingData.nbEnAttente,
                titleNotBold: _ctx.$t('widgetBilling.facture', _ctx.getBillingData.nbEnAttente),
                titleInBold: _ctx.$t('widgetBilling.attente'),
                titleEnd: _ctx.$t('widgetBilling.paiement'),
                color: '--en-attente',
                fontSize: '19px',
                isLoading: _ctx.isLoading,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigateTo('/facturation/echeance')))
              }, null, 8, ["value", "titleNotBold", "titleInBold", "titleEnd", "isLoading"]),
              _createVNode(_component_Tile, {
                class: "tile",
                value: _ctx.getBillingData.nbPayees,
                titleNotBold: _ctx.$t('widgetBilling.facture', _ctx.getBillingData.nbPayees),
                titleInBold: _ctx.$t('widgetBilling.payees'),
                color: '--fait',
                fontSize: '19px',
                isLoading: _ctx.isLoading,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigateTo('/facturation/payee')))
              }, null, 8, ["value", "titleNotBold", "titleInBold", "isLoading"])
            ]),
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_ContentLoader, {
                  key: 0,
                  width: "150",
                  height: "70"
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createTextVNode(_toDisplayString(_ctx.$t('widgetBilling.jourEnRetard')) + " ", 1),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('widgetBilling.nbJourEnRetard', { count: _ctx.getBillingData.nbMaxJourRetard || 0 })), 1)
                  ])
                ]))
          ]))
    ]),
    _: 1
  }))
}